import { faSync } from '@fortawesome/pro-light-svg-icons'
import { useCallback } from 'react'
import { ITLayoutTableModalOpenSetTy } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { RowData } from '../../../../../../../baseComponents/TwinTable/types'
import { ParameterValueType } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { TwinIconToolTip } from '../../../../../../../baseComponents/TwinIcon'

export interface OrderSyncProductPriceProps {
    setOpenModal: ITLayoutTableModalOpenSetTy
    value: ParameterValueType
    allRowData: RowData
    readOnlyFnc?: (allRowData: RowData) => boolean
}

const OrderSyncProductPrice: React.FC<OrderSyncProductPriceProps> = ({ setOpenModal, allRowData, readOnlyFnc }) => {
    const { t } = useTwinTranslation()
    const manualPrice = allRowData?.manualPrice
    const readOnly = readOnlyFnc?.(allRowData)

    const myOpenModal = useCallback(() => {
        if (manualPrice) {
            setOpenModal({ type: 'syncPrice', allRowData })
        }
    }, [setOpenModal, allRowData, manualPrice])

    if (!manualPrice || readOnly) {
        return null
    }

    return (
        <div className='flex justify-center items-center flex-auto'>
            <TwinIconToolTip className={manualPrice ? 'text-red-BA' : 'text-green-21'} message={manualPrice ? t('syncPrice', 'Sincronizar precio') : ''} id={'syncPrice' + allRowData?.id || ''} icon={faSync} onClick={myOpenModal} />
        </div>
    )
}

export default OrderSyncProductPrice
